import * as moment from 'moment';

import { IDataSorter } from 'app/slick-grid/interfaces/data-sorter';

export class DataSorter<T extends Slick.SlickData> implements IDataSorter<T> {
    constructor(public readonly languageCode?: string) {
        this.customComparers = {};
    }

    readonly customComparers: { [fieldId: string]: (a: T, b: T, dataSorter: IDataSorter<T>) => number; };

    readonly multiColumnSorter = (a: T, b: T, sortCols: Slick.SortColumn<T>[]): number => {
        for (const col of sortCols) {
            const result = this.sorter(a, b, col.sortCol, col.sortAsc);
            if (result !== 0)
                return result;
            //const result = this.compare(a, b, col.sortCol.field);
            //if (result !== 0)
            //    return !col.sortAsc ? result * -1 : result;
        }

        return 0;
    }

    private useIntlCollator: boolean;

    readonly sorter = (a: T, b: T, col: Slick.Column<T>, sortAsc: boolean): number => {
        const result = this.compare(a, b, col.field);
        // console.log(result, this.languageCode, 'sorter')
        return sortAsc ? result : (result * -1);
        // return sortAsc && !this.useIntlCollator ? result : (result * -1);
    }

    readonly sort = (args: Slick.OnSortEventArgs<T>): void => {
        console.log(args, 'sort helper')
        const data = args.grid.getData();
        if (!data)
            return;
        const sort: (a: T, b: T) => number =
            args.multiColumnSort
                ? (a, b)=> this.multiColumnSorter(a, b, args.sortCols)
                : (a, b) => this.sorter(a, b, args.sortCol, args.sortAsc);

        if (data instanceof Slick.Data.DataView) {
            (data as Slick.Data.DataView<T>).sort(sort, true);
            return;
        }

        data.sort(sort);
        args.grid.invalidate();
        args.grid.render();
    }

    readonly compare = (a: T, b: T, field?: string): number => {
        this.useIntlCollator = false;
        if (field != null) {
            const customCompare = this.customComparers[field];
            if (customCompare)
                return customCompare(a, b, this);
        }

        return this.defaultCompare(a, b, field);
    }

    public readonly defaultCompare=(a: T, b: T, field?: string): number => {
        let valA = field ? a[field] : a;
        let valB = field ? b[field] : b;
        // console.log(this.languageCode, 'defaultCompare')
        if (moment.isDuration(valA) || moment.isDuration(valB)) {
            valA = valA == null ? null : valA.asMilliseconds();
            valB = valB == null ? null : valB.asMilliseconds();
        } else if (moment.isMoment(valA) || moment.isMoment(valB)) {
            valA = valA == null ? null : valA.valueOf();
            valB = valB == null ? null : valB.valueOf();
        }

        if (this.languageCode){
            this.useIntlCollator = true;
        }
            //try {
            //    return valA == null && valB == null ? 0 : valA == null && valB != null ? -1 : valB == null && valA != null ? 1 : valA.diff(valB);
            //} catch (e) {
            //    return 0;
            //}
        //else
        if (valA === valB || (valA == null && valB == null)){
            return 0;
        } else {
            if (this.languageCode && (typeof valA === 'string' || typeof valB === 'string')){
                valA === null ? valA = '' : null;
                valB === null ? valB = '' : null;

                // console.log(valA, valB, Intl.Collator(this.languageCode).compare(valA,valB), 'defaultCompare Intl.Collator')
                return new Intl.Collator(this.languageCode).compare(valA,valB);
            } else {
                return valA > valB || (valA != null && valB == null) ? 1 : -1;
            }


        }
            /*return valA === valB || (valA == null && valB == null)
                ? 0
                : (this.languageCode
                    ? new Intl.Collator(this.languageCode).compare(valA,valB)
                    // ? valA > valB
                    : valA > valB
                    || (valA != null && valB == null))
                    ? 1
                    : -1;*/
    }

    //private sortByMultipleColumns = (a: T, b: T, columns: Slick.SortColumn<T>[]): number => {
    //    for (const col of columns) {
    //        const result = this.compare(a, b, col.sortCol.field);
    //        if (result !== 0)
    //            return !col.sortAsc ? result * -1 : result;
    //    }

    //    return 0;
    //}

    //private sortByColumn = (a: T, b: T, column: Slick.SortColumn<T>): number => {
    //    const result = this.compare(a, b, column.sortCol.field);
    //    return !args.data.sortAsc ? result * -1 : result;
    //}
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/data-sorter.ts